export const ACCOUNT_MIN_WIDTH = 63.5
